const templates = {
  NO_SIDEBAR: 'No Side Menu',
  HOMEPAGE: 'Homepage',
};

export default templates;
